import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.colors.lightTeal,
    },
    borderRadius: 8,
    border: [1, 'solid', theme.palette.colors.divider],
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    height: 50,
  },
  infoBox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerName: {
    width: '20%',
    marginLeft: theme.spacing(1),
  },
  companyInfo: {
    width: '30%',
  },
  companyInfoItem: {
    display: 'flex',
    alignItems: 'center',
  },
  companyInfoItemLabel: {
    width: '50%',
    textAlign: 'right',
    marginRight: theme.spacing(1),
  },
  loanOfficerInfo: {
    width: '25%',
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerEmail: {
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerInfoLabel: {
    marginRight: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/LoanOfficersList/components/LoanOfficerCard/useStyles.js